export default __webpack_public_path__ + "static/media/photo--lg--44.dca6cd9e.jpg";